import './App.css';
import LinkButton from './components/LinkButton/LinkButton';
function App() {
    return (

        <div className="App">
            <header className="App-header">
                <div id={"bot-introduction"}>
                    <h1 className={"title"}>League of Legends Clash Scouter</h1>
                    <p className={"main-text"}>
                        Add the League of Legends clash scouter bot to your Discord server by clicking the button below!
                    </p>
                </div>
            </header>
            <LinkButton />
            <p>How it works: </p>
            <img id={"clash-gif"} src={"/clashscouter.gif"} alt={"gif of how to use the clash scouter"} />
        </div>
    );
}

export default App;
